import { ShieldCheck } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { RegulatoryCustomerPage } from './pages/RegulatoryCustomerPage'
import { RegulatoryRequestPage } from './pages/RegulatoryRequestPage'

/**
 * Regulatory — Customer (2026-05-29).
 *
 * Customer-facing regulatory requests (COA / SDS / TDS / compliance /
 * spec dossier / INCI …). A fully separate sibling of Regulatory — Vendor,
 * matching the Customer Pricelists / Vendor Pricelists split: distinct nav
 * entry, distinct board, customer-only stage set + activities. Shares the
 * board implementation via @/shell/services/regulatory.
 */
export default defineModule({
  id: 'regulatory-customer',
  name: 'Regulatory — Customer',
  shortName: 'Reg. Customer',
  icon: ShieldCheck,
  navSection: 'regulatory',
  navOrder: 10,
  urlNamespace: '/regulatory/customer',
  routes: [
    { path: '/', element: RegulatoryCustomerPage, label: 'Regulatory — Customer' },
    { path: '/$requestId', element: RegulatoryRequestPage, label: 'Regulatory request' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'regulatory'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g g',

  commandPaletteEntries: [
    {
      label: 'Go to Regulatory — Customer',
      keywords: ['regulatory', 'customer', 'coa', 'sds', 'tds', 'compliance', 'inci'],
      path: '/',
      group: 'modules',
      shortcut: 'g g',
    },
  ],
})
